import { ShieldCheck, Mail, LogOut } from 'lucide-react';
import { useAuthStore } from '../../store/useAuthStore';
import { Button } from '../ui/button';
import { publicSupport } from '../../content/publicSite';

// Shown on the dashboard when the signed-in account is not linked to a tenant/workspace
// (bootstrap returned no business). Tenant provisioning is SuperAdmin-owned — the tenant
// app cannot create or update a business without an existing tenant (see BusinessService:
// CreateBusinessAsync is a hard fail, UpdateBusinessAsync needs a real tenantId). So instead
// of the old self-service "Regional Preferences" wizard — which could never submit and had
// no close affordance, trapping the user — we surface the real state (pending provisioning)
// with a genuine escape route: Sign out.
export function WorkspaceNotReady() {
  const logout = useAuthStore((s) => s.logout);

  return (
    <div className="fixed inset-0 z-[210] flex items-center justify-center bg-background/95 p-4 backdrop-blur-sm">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="workspace-not-ready-title"
        aria-describedby="workspace-not-ready-desc"
        data-testid="workspace-not-ready"
        className="w-full max-w-md space-y-5 rounded-2xl border border-border bg-card p-8 text-center shadow-lg"
      >
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-accent">
          <ShieldCheck className="h-7 w-7 text-primary" aria-hidden="true" />
        </div>

        <div className="space-y-2">
          <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground">
            Workspace pending
          </span>
          <h1 id="workspace-not-ready-title" className="text-2xl font-bold tracking-tight text-foreground">
            Your workspace isn't ready yet
          </h1>
          <p id="workspace-not-ready-desc" className="text-sm text-muted-foreground">
            Your account isn't linked to a business workspace yet. Provisioning is handled by our
            team — you'll receive an email as soon as your workspace is ready for guided setup.
          </p>
        </div>

        <div className="space-y-3 pt-1">
          <a
            href={`mailto:${publicSupport.supportEmail}`}
            className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-border bg-background px-4 py-3 text-sm font-medium text-foreground motion-safe:transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            <Mail className="h-4 w-4" aria-hidden="true" />
            Contact support
          </a>
          <Button
            type="button"
            variant="outline"
            onClick={() => logout()}
            data-testid="workspace-not-ready-signout"
            className="w-full"
          >
            <LogOut className="h-4 w-4" aria-hidden="true" />
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
